// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ_faq__22uOm","faq__background":"FAQ_faq__background__3uXUQ","faq__title":"FAQ_faq__title__2TmD5","faq__list":"FAQ_faq__list__3hG6w"};